export default {
    showBorders: false,
    filterRow: {
        visible: false,
    }
};
